<template>
  <div style="width: 100%">
    <div
      style="width: 100%"
      class="blog_topic_fm row row-cols-1 row-cols-sm-2 row-cols-md-2 g-1"
    >
      <div
        class="col"
        v-for="(item, ix) in list"
        @click="
          $router.push({
            name: 'blogDetail',
            query: {
              id: item.id,
            },
          })
        "
      >
        <div class="blog_topic">
          <div class="blog_bgpic" width="100%" height="300">
            <img :src="item.sgL_UploadTempUrl" class="topic_img" />
            <p class="topic_title">
              {{ item.sgL_Title }}
            </p>
          </div>
          <div class="blog_topic_info">
            <p class="topimg_icon">
              <img :src="item.sgL_UsersBLog" /><span class="txt">{{
                item.sgL_BlogName
              }}</span>
            </p>
            <p class="user_icon">
              <img :src="item.userLogoSmail" />
            </p>
            <p class="user_info">
              <span class="txt">{{ item.sgL_UsersName }}</span>
              <span class="postime">{{ item.sgL_CreateTimeE }}</span>
            </p>
            <p class="blog_desciption">
              <span>{{
                item.sgL_Content.replace(/<\/?.+?>/g, "").replace(/ /g, "")
              }}</span>
            </p>
            <p class="blog_count">
              <span class="view"
                ><i class="fas fa-eye">{{ item.sgL_ViewCount }}</i></span
              >
              <span class="like"
                ><i class="fas fa-thumbs-up">{{ item.sgL_LikeCount }}</i></span
              >
              <span class="share"
                ><i class="fas fa-share">{{ item.sgL_SharCount }}</i></span
              >
            </p>
          </div>
        </div>
      </div>
    </div>
    <div>
      <cardList v-if="sgL_NotInId.length" :sgL_NotInId="sgL_NotInId"></cardList>
    </div>
  </div>
</template>

<script>
import cardList from "@/components/blog/cardList";
export default {
  components: { cardList },
  data() {
    return {
      list: [],
      sgL_NotInId: [],
    };
  },
  created() {
    this.GetAll();
  },
  methods: {
    GetAll() {
      let params = {
        SkipCount: 0,
        MaxResultCount: 4,
        selectAll: true,
        sgL_IsShow: true,
      };
      this.$api.blog.GetAll(params).then((res) => {
        this.list = res.data.result.items;
        this.sgL_NotInId = this.list.map((item) => {
          return item.id;
        });
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/blog/all.vue